import { v4 as uuidv4 } from 'uuid';
import { DeliveryWindow } from './index';

export const deliveryWindowsMocked: DeliveryWindow[][] = [
  [
    {
      pickupStart: '2022-01-01T13:00:00Z',
      pickupEnd: '2022-01-01T14:00:00Z',
      dropoffStart: '2022-01-01T15:00:00Z',
      dropoffEnd: '2022-01-01T16:00:00Z',
      id: uuidv4()
    },
    {
      pickupStart: '2022-01-01T14:00:00Z',
      pickupEnd: '2022-01-01T15:00:00Z',
      dropoffStart: '2022-01-01T16:00:00Z',
      dropoffEnd: '2022-01-01T17:00:00Z',
      id: uuidv4()
    },
    {
      pickupStart: '2022-01-01T15:00:00Z',
      pickupEnd: '2022-01-01T16:00:00Z',
      dropoffStart: '2022-01-01T17:00:00Z',
      dropoffEnd: '2022-01-01T18:00:00Z',
      id: uuidv4()
    },
    {
      pickupStart: '2022-01-01T16:00:00Z',
      pickupEnd: '2022-01-01T17:00:00Z',
      dropoffStart: '2022-01-01T18:00:00Z',
      dropoffEnd: '2022-01-01T19:00:00Z',
      id: uuidv4()
    },
    {
      pickupStart: '2022-01-01T17:00:00Z',
      pickupEnd: '2022-01-01T18:00:00Z',
      dropoffStart: '2022-01-01T19:00:00Z',
      dropoffEnd: '2022-01-01T20:00:00Z',
      id: uuidv4()
    }
  ],
  [
    {
      pickupStart: '2022-01-02T13:00:00Z',
      pickupEnd: '2022-01-02T14:00:00Z',
      dropoffStart: '2022-01-02T15:00:00Z',
      dropoffEnd: '2022-01-02T16:00:00Z',
      id: uuidv4()
    },
    {
      pickupStart: '2022-01-02T14:00:00Z',
      pickupEnd: '2022-01-02T15:00:00Z',
      dropoffStart: '2022-01-02T16:00:00Z',
      dropoffEnd: '2022-01-02T17:00:00Z',
      id: uuidv4()
    },
    {
      pickupStart: '2022-01-02T15:00:00Z',
      pickupEnd: '2022-01-02T16:00:00Z',
      dropoffStart: '2022-01-02T17:00:00Z',
      dropoffEnd: '2022-01-02T18:00:00Z',
      id: uuidv4()
    },
    {
      pickupStart: '2022-01-02T16:00:00Z',
      pickupEnd: '2022-01-02T17:00:00Z',
      dropoffStart: '2022-01-02T18:00:00Z',
      dropoffEnd: '2022-01-02T19:00:00Z',
      id: uuidv4()
    },
    {
      pickupStart: '2022-01-02T17:00:00Z',
      pickupEnd: '2022-01-02T18:00:00Z',
      dropoffStart: '2022-01-02T19:00:00Z',
      dropoffEnd: '2022-01-02T20:00:00Z',
      id: uuidv4()
    }
  ],
  [
    {
      pickupStart: '2022-01-03T13:00:00Z',
      pickupEnd: '2022-01-03T14:00:00Z',
      dropoffStart: '2022-01-03T15:00:00Z',
      dropoffEnd: '2022-01-03T16:00:00Z',
      id: uuidv4()
    },
    {
      pickupStart: '2022-01-03T14:00:00Z',
      pickupEnd: '2022-01-03T15:00:00Z',
      dropoffStart: '2022-01-03T16:00:00Z',
      dropoffEnd: '2022-01-03T17:00:00Z',
      id: uuidv4()
    },
    {
      pickupStart: '2022-01-03T15:00:00Z',
      pickupEnd: '2022-01-03T16:00:00Z',
      dropoffStart: '2022-01-03T17:00:00Z',
      dropoffEnd: '2022-01-03T18:00:00Z',
      id: uuidv4()
    },
    {
      pickupStart: '2022-01-03T16:00:00Z',
      pickupEnd: '2022-01-03T17:00:00Z',
      dropoffStart: '2022-01-03T18:00:00Z',
      dropoffEnd: '2022-01-03T19:00:00Z',
      id: uuidv4()
    },
    {
      pickupStart: '2022-01-03T17:00:00Z',
      pickupEnd: '2022-01-03T18:00:00Z',
      dropoffStart: '2022-01-03T19:00:00Z',
      dropoffEnd: '2022-01-03T20:00:00Z',
      id: uuidv4()
    }
  ]
];
